import styled from "styled-components";

export const Background = styled.div`
  background-image: linear-gradient(#00FFFF, #000FFF);
  height: 100vh;
  overflow: hidden;
`;

export const Container = styled.div`
  width: 90%;
  height: 95%;
  position: relative;
  bottom: -2%;
  background-color: #ffffff;
  overflow-y: hidden;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  margin: 0 auto;

  @media(min-width: 768px) {
    margin: -2.75rem auto 0rem auto;
    width: 97%;
    height: 91%;
    padding: 2rem;
    max-height: 100vh;
    overflow: auto;
    border-radius: .7rem;
    bottom: -5%;
  }

  @media(min-width: 1300px) {
    width: 98%;
  }
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;

  @media (max-width: 1015px){
    flex-direction: column;
  }
`;

export const PageIcon = styled.img`
  width: 50px;
  height: 42px;
  margin-right: 30px;

  @media(max-width: 768px) {
    width: 40px;
    height: 32px;
    margin-right: 10px;
  }
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const PageContent = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const VideosContainer = styled.div`
  width: 100%;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1150px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px){
    grid-template-columns: 1fr;
  }
`;

export const Content = styled.div`
  overflow-y: scroll;
  height: 95%;
  width: 100%;

  /* @media(min-width: 768px) {
    ${PageTitleContainer} {
      display: none;
    }
  } */
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const Search = styled.input`
  box-shadow: 0px 1px 2px #00000034;
  border: 0.5px solid #949494;
  border-radius: 18px;
  width: 493px;
  height: 35px;
  padding: 0px 20px;
  @media (max-width: 768px){
    width: 100%;
  }
`;

export const SearchDivision = styled.div`
  width: 493px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DivisionSearchIcon = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SearchIcon = styled.img`
  left: -1rem;
  top: 2.6rem;
  position: relative;
  width: 15px;
  height: 15px;
`;

export const SearchBox = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px){
    width: 100%;
  }
`;

export const SearchTags = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 768px){
    margin-top:10px;
  }
`;

export const SearchTag = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #D5D5D5;
  padding: 5px 13px;
  color: #808080;
  margin-right: 19px;
  opacity: ${props => (props.opacity) ? '0.5' : '1'};
  &:hover {
    cursor: pointer;
  }
`;
export const SearchTagClose = styled.div`
  margin-left: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  background: #808080;
  color: #FFF;
  text-align: center;
  font-size: 10px;
  border-radius: 30px;
`;

export const TagsBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: end;
  padding: 0px 20px;
  margin-top: 20px;
  margin-bottom: 20px;

  @media (min-width: 768px){
    display: ${props => (props.mobile) ? 'none' : 'flex'};
  }
  @media (max-width: 768px){
    display: ${props => (props.desktop) ? 'none' : 'flex'};
    flex-wrap: wrap;
    padding: 0px;
    margin-bottom: 0px;
  }
`;

export const Tag = styled.div`
  padding: 3px 12px;
  color: ${props => (props.selected) ? '#FFF' : '#B2B2B2'};
  background: ${props => (props.selected) ? '#000FFF' : '#FFF'};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 20px;
  margin-right: 21px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 768px){
    margin-bottom: 10px;
  }
`;

export const Header = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000FFF;
  color: #ffffff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 5px;
  margin-bottom: 23px;
  @media (min-width: 768px){
    display: none;
  }
`;

export const HeaderIcon = styled.i`
  font-size: 29px;
  color: #ffffff;
`;

export const HeaderText = styled.span`
  font-size: 15px;
  color: #ffffff;
`;

export const TitleIconDivision = styled.div`
  display: flex;
  align-items: center;
  margin: 2.5rem 0 1rem 0;
`;

export const HeaderDivision = styled.div`
  @media(min-width: 768px) {
    display: none
  }
`;

export const DivisionBackIcon = styled.div`
  display: flex;
  justify-content: flex-end;

  @media(min-width: 768px) {
    display: none;
  }
`;

export const CloseIcon = styled.img`
  width: 22px;
  height: auto;
  /* margin: 1rem 0 0rem 0; */

  @media(min-width: 768px) {
    margin: 1rem 0 1rem 0;
  }
`;

export const ContainerCloseIcon = styled.div`
  width: 95.5%;
  display: flex;
  justify-content: flex-end;

  @media(min-width: 770px) {
    width: 98.8%;
  }
`;

export const AlignNoVideos = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;

  span {
    color: #808080;
  }
`;

export const FacebookLink = styled.a`
  width: 6rem;
  height: 5rem;
  margin-top: -1%;

  @media(max-width: 770px) {
    width: 9rem;
  }

  img {
    width: 100%;
  }
`;

export const BoxMobile = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 50%;

  @media(min-width: 570px) and (max-width: 770px) {
    flex-wrap: nowrap;
    align-items: center;
  }
`;
